module.exports = __webpack_public_path__ + "static/img/logincloseimg2.054f82d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/images/logincloseimg2.png
// module id = 1013
// module chunks = 1